import React from "react";
import Checkbox from "../../components/checkbox";

interface PieceFilterChooseListProps {
    options: string[];
    active: number;
    onClick: (v: number) => void;
}

export default function PieceFilterChooseList(props: PieceFilterChooseListProps) {

    return <ul>
        {props.options.map((e, i) => {
            return <Checkbox key={i} value={props.active == i} label={e} onClick={(v: boolean) => {
                if(v) {
                    props.onClick(i);
                }else {
                    props.onClick(-1);
                }
            }}/>;
        })}
    </ul>

}